module.exports = __webpack_public_path__ + "static/img/whatsapp.13f53aa8.png";